import React from 'react';
import { Subscription } from 'src/constrains/AdvancedFilters/Components';

// radioName,
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { IntClear } from '../Components';
const _Subscription = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { radioName, root, state, form, onChangeCb, disabled } = props;
  return (
    <SectionWrapper
      title={getI18n('customerTag.subscription.subscriptionstatus')}>
      <ItemWrapper title=''>
        <Subscription radioName={radioName} disabled={disabled} />
        <IntClear
          onChangeCb={onChangeCb}
          form={form}
          root={root}
          value={radioName}
          state={state}
          disabled={disabled}
        />
      </ItemWrapper>
    </SectionWrapper>
  );
};
export default _Subscription;
